import React from 'react'

export default ({ onChange, value, placeholder, marginTop, name, disabled }) => (<input className='input' name={name} type='text' placeholder={placeholder} value={value} onChange={onChange} style={{ alignSelf: 'stretch', marginTop }} disabled={disabled} />)


// WEBPACK FOOTER //
// ./src/components/Regular/Input.js